import React from 'react';
import '../styles/InfoB.css';
const InfoB = () => {
  return (
    <article className='info-b-wrapper'>
      <section className='info-b'>
        <h1>Ut enim ad minima </h1>
        <p>
          At vero eos et accusamus et iusto odio dignissimos <br /> ducimus qui
          blanditiis
        </p>
      </section>
    </article>
  );
};

export default InfoB;
